export const enum ReserveStates_enum {
  CANCEL = "cancel",
  EXPIRED = "expired",
  HOST_APPROVAL = "host_approval",
  SECOND_PAYMENT = "second_payment",
  DONE = "done",
}
